<template>
  <v-dialog class="blur-dialog" transition="fade-transition" persistent :value="value" @input="$emit('input', false)" fullscreen dark>
    <v-card style="background: rgba(21, 21, 21, 0.7); backdrop-filter: blur(10px)" flat class="d-flex flex-column fill-height">
      <v-toolbar dark color="transparent" flat>
        <v-spacer></v-spacer>
        <v-btn icon large @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="flex-grow-1 d-flex justify-center align-center pa-0">
        <SecuredMedia v-if="item" :filename="item.fileUrl" :mediaType="item.messageType" class="fullscreen-media-content" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// Wir importieren unsere bestehende Komponente
import SecuredMedia from "./securedMedia.vue"

export default {
  name: "MediaViewerDialog",
  components: { SecuredMedia },
  props: {
    value: Boolean, // Für v-model
    item: {
      type: Object,
      default: null, // (Guter Standardwert)
    },
  },
}
</script>

<style lang="scss" scoped>
/* Stellt sicher, dass das Video/Bild den Platz nutzt, aber nicht überläuft */
.fullscreen-media-content {
  ::v-deep .secured-media-content {
    max-width: 90vw;
    max-height: 90vh;
    border-radius: 8px; /* (Optional, aber schön) */
  }
}
::v-deep .blur-dialog.fade-transition-enter-active {
  /* Standard ist ca. 0.3s, wir machen es viel langsamer */
  transition: opacity 2s ease !important;
}

/* Steuert das AUSBLENDEN (kann schneller sein, wenn du willst) */
::v-deep .blur-dialog.fade-transition-leave-active {
  transition: opacity 2s ease-out !important;
}
</style>
